import MessagesAsideItem from "./MessagesAsideItem"
import ScrollBlock from "../../Assets/ScrollBlock"
import { IChat, IChatInfoExt } from "../../../types/chat"
import clsx from "clsx"
import { useInfiniteScroll } from "../../../hooks/useInfiniteScroll"
import MessagesAsideListLoader from "./MessagesAsideListLoader"
import styles from "./MessagesModal.module.scss"

const MessagesAsideList = ({
  list,
  activeChat,
  isLoading,
  callbackSearch,
  onClick,
  isAllChats,
}: {
  list: IChatInfoExt[]
  activeChat: { id: string; name: string | null | undefined; userID?: string | null }
  isLoading?: boolean
  callbackSearch?: () => void
  onClick: (val: string, name: string, userID: string | null) => void
  isAllChats: boolean
}) => {
  let scrollTimeout: any
  const infiniteScroll = useInfiniteScroll<HTMLDivElement>(
    async () => {
      if (isAllChats) return
      await new Promise((resolve) => {
        clearTimeout(scrollTimeout)
        scrollTimeout = setTimeout(resolve, 1500)
        if (!callbackSearch) return
        callbackSearch()
      })
    },
    { distance: 10, isScrollPlugin: true },
  )

  return (
    <ScrollBlock
      //@ts-ignore
      ref={infiniteScroll.ref}
      hideTracksWhenNotNeeded
      fullHeightScrollBar
      scrollBarSize={4}
      className={clsx(styles.asideList, "asideList")}
    >
      {list.map((item, index) => (
        <MessagesAsideItem
          key={index}
          {...item}
          isActive={
            activeChat.id ? item.id === activeChat.id : activeChat.userID ? item.user_id === activeChat.userID : false
          }
          onClick={onClick}
          className={styles.item}
        />
      ))}
      {infiniteScroll.isLoading || isLoading ? <MessagesAsideListLoader /> : null}
      {/*{isLoading && !list?.length && <AsideListLoader />}*/}
    </ScrollBlock>
  )
}

export default MessagesAsideList
